/**
 * What each tool an agent calls does, in plain words in both languages: the conversation and the event stream name the work, never the
 * endpoint or the internal tool key, and never a timing (V10, V11). Kept free of imports so the engine can use it.
 */
const LABELS: Record<string, { en: string; ar: string }> = {
  "ai.compare": { en: "Compare the public pages with the filing", ar: "مقارنة الصفحات العامة بالطلب" },
  "ai.dispatch": { en: "Start a drafting run on the platform", ar: "بدء صياغة في المنصة" },
  "analysis.figures": { en: "The file's figures, by the published method", ar: "أرقام الملف وفق المنهجية المنشورة" },
  "analysis.method": { en: "The published calculation method", ar: "منهجية الحساب المنشورة" },
  "analysis.market-history": { en: "The market's history in the Data Bank", ar: "تاريخ السوق في بنك البيانات" },
  "analysis.share-verification": { en: "Shares against independent data", ar: "الحصص مقابل البيانات المستقلة" },
  "corpus.search": { en: "Search the legal library", ar: "البحث في المكتبة القانونية" },
  "databank.graph": { en: "Ownership links in the Data Bank", ar: "روابط الملكية في بنك البيانات" },
  "databank.intelligence": { en: "Market information in the Data Bank", ar: "معلومات السوق في بنك البيانات" },
  "dealwatch.by-case": { en: "Deal watch for this file", ar: "رصد الصفقات لهذا الملف" },
  "dealwatch.search": { en: "Search the deal watch", ar: "البحث في رصد الصفقات" },
  "documents.list": { en: "The filed documents", ar: "المستندات المودعة" },
  "documents.read": { en: "Read a filed document", ar: "قراءة مستند مودع" },
  "documents.status": { en: "A document's text extraction", ar: "استخراج نص مستند" },
  "ec.checks": { en: "The filing checks", ar: "فحوص الإيداع" },
  "ec.coordination": { en: "Other authorities and regulators", ar: "الجهات الأخرى والجهات التنظيمية" },
  "ec.efficiencies": { en: "The efficiency screen", ar: "اختبار الكفاءات" },
  "ec.publication": { en: "The notice on the Ministry's website", ar: "الإعلان على موقع الوزارة" },
  "ec.qualification": { en: "The control and qualification test", ar: "اختبار السيطرة والتصنيف" },
  "ec.readiness": { en: "The completeness checklist", ar: "قائمة الاكتمال" },
  "ec.simplified": { en: "The simplified-procedure screen", ar: "اختبار الإجراء المبسط" },
  "ec.statutory-clock": { en: "The statutory period", ar: "المدة القانونية" },
  "ec.thresholds": { en: "The notification thresholds", ar: "حدود الإخطار" },
  "economics.run": { en: "Pricing pressure and simulation", ar: "الضغط السعري والمحاكاة" },
  "legal.rules": { en: "The platform's legal register", ar: "السجل القانوني للمنصة" },
  "memory.review": { en: "The Department's recorded practice", ar: "الممارسة المسجلة في الإدارة" },
  "memory.remember": { en: "Record a practice for later files", ar: "تسجيل ممارسة للملفات اللاحقة" },
  "news.search": { en: "The press and market feeds", ar: "الصحافة وتغذيات السوق" },
  "registry.lookup": { en: "The commercial register", ar: "السجل التجاري" },
  "web.search": { en: "Search the open web", ar: "البحث في الويب المفتوح" },
  "workflow.interests": { en: "Declaration of interests", ar: "إقرار تضارب المصالح" },
  "workflow.override": { en: "Override with the officer's reasons", ar: "تجاوز بأسباب الموظف" },
  "workflow.read": { en: "The file's procedure", ar: "إجراء الملف" },
  "workflow.transition": { en: "Move the file to its next step", ar: "نقل الملف إلى خطوته التالية" },
};

const OTHER = { en: "A platform tool", ar: "أداة من أدوات المنصة" };

/** The tool's work in both languages; a tool outside this list (a platform run's own step) reads as a platform tool. */
export function toolLabel(name: string): { en: string; ar: string } {
  return LABELS[name] ?? OTHER;
}
